import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import SVG from "theme/components/icons/base/SVG";

const StyledSVG = styled(SVG)`
    & > * {
        transition: transform ${({ theme }) => theme.transitions.secondary};
    }
`;

const SortIcon = ({ color, ...props }) => (
    <StyledSVG className="sort-icon" fill="none" {...props}>
        <line className="first" y1="2.5" x2="6" y2="2.5" stroke={color} />
        <line y1="6.5" x2="9" y2="6.5" stroke={color} />
        <line className="second" y1="10.5" x2="12" y2="10.5" stroke={color} />
    </StyledSVG>
);

SortIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

SortIcon.defaultProps = {
    color: "#000",
    height: "12px",
    viewBox: "0 0 12 12",
    width: "12px",
};

export default SortIcon;
